import React, { useState } from 'react';
import { Send, CheckCircle, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    organization: '',
    contact: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    setTimeout(() => {
      toast.success('Mensagem enviada. Entraremos em contacto brevemente.');
      setFormData({
        name: '',
        organization: '',
        contact: '',
        message: ''
      });
      setIsSubmitting(false);
    }, 1500);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Pedir Contacto
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Preencha o formulário e entraremos em contacto para uma primeira conversa.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl">
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <Label htmlFor="name">Nome *</Label>
                  <Input
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Nome completo"
                    className="mt-2"
                  />
                </div>

                <div>
                  <Label htmlFor="organization">Entidade *</Label>
                  <Input
                    id="organization"
                    name="organization"
                    value={formData.organization}
                    onChange={handleChange}
                    required
                    placeholder="Nome da entidade"
                    className="mt-2"
                  />
                </div>

                <div>
                  <Label htmlFor="contact">Email ou Telefone *</Label>
                  <Input
                    id="contact"
                    name="contact"
                    value={formData.contact}
                    onChange={handleChange}
                    required
                    placeholder="Contacto preferencial"
                    className="mt-2"
                  />
                </div>

                <div>
                  <Label htmlFor="message">Mensagem</Label>
                  <Textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={6}
                    placeholder="Descreva brevemente o seu pedido (opcional)"
                    className="mt-2"
                  />
                </div>

                <div className="flex items-start gap-3 p-4 bg-blue-50 rounded-xl border border-blue-200">
                  <CheckCircle className="text-blue-600 flex-shrink-0 mt-0.5" size={20} />
                  <p className="text-sm text-blue-900">
                    Os seus dados serão tratados com confidencialidade de acordo com a nossa política de privacidade.
                  </p>
                </div>

                <Button
                  type="submit"
                  size="lg"
                  disabled={isSubmitting}
                  className="w-full bg-brand-green hover:bg-brand-green-dark text-white font-semibold transition-all duration-300 hover:scale-105"
                >
                  {isSubmitting ? (
                    'A enviar...'
                  ) : (
                    <>
                      Pedir Contacto
                      <Send className="ml-2" size={18} />
                    </>
                  )}
                </Button>
              </form>
            </div>

            {/* Address */}
            <div className="mt-12 text-center">
              <div className="flex items-center justify-center gap-3 text-gray-600">
                <MapPin size={20} className="text-brand-green" />
                <span>Avenida Júlio Graça n.º 460, 4.º<br />4480-672 Vila do Conde</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
